/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const batchAddDefects = /* GraphQL */ `
  mutation BatchAddDefects($defects: [CreateDefectInput]) {
    batchAddDefects(defects: $defects) {
      id
      customerId
      vehicleId
      vehicle {
        id
        customerVehicleId
        inspections {
          nextToken
        }
        customer {
          id
          calbitCustomerID
          companyName
          customerFirstName
          customerLastName
          email
          registrationDate
          accountStatus
          customerOverAllRating
          generalInstructions
          registeredInspectionType
          createdAt
          updatedAt
        }
        make
        model
        VIN
        vehicleYear
        license
        locationLat
        locationLong
        nextInspectionDue {
          inspectionType
          nextDueDate
        }
        notes
        deactivateBIT
        deactivateDOT
        currentMileage
        currentMileageLastUpdated
        vehicleType {
          id
          vehicleType
          vehicleCategory
          observations
          createdAt
          updatedAt
        }
        specialInstructions
        mainPic {
          bucket
          region
          key
        }
        vinPic {
          bucket
          region
          key
        }
        licensePic {
          bucket
          region
          key
        }
        vehicleUploads {
          bucket
          region
          key
        }
        oilService {
          oilServiceType
          intervalValue
          currentMileage
          currentMileageLastUpdated
          lastTimeOilChangedAt
        }
        filters {
          filterCategory
          filterNumber
          notes
        }
        specialParts {
          partName
          partNumber
        }
        vehicleStatus
        defects {
          nextToken
        }
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      defectType
      defectDesc
      redTag
      priority
      status
      reportedByUserType
      reportedByUserId
      reportedDateTime
      sourceType
      sourceId
      assignedToUserType
      assignedToUserId
      assignedAtDateTime
      assignedByUserId
      assignmentNote
      isAccepted
      assignmentHistory {
        assignedToUserId
        assignedToUserType
        assignedAtDateTime
        assignmentNote
        refusedAtDateTime
        refusalNote
        assignedByUserId
      }
      repairedByUserType
      repairedByUserId
      repairedDateTime
      repairNotes
      partsUsedInRepair
      defectUploads {
        bucket
        region
        key
      }
      notes {
        items {
          id
          noteText
          noteType
          defectID
          addedByUserId
          addedByUserGroup
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createInspector = /* GraphQL */ `
  mutation CreateInspector(
    $input: CreateInspectorInput!
    $condition: ModelInspectorConditionInput
  ) {
    createInspector(input: $input, condition: $condition) {
      id
      name
      homeAddress
      city
      state
      phoneNo
      email
      overAllRating
      inspectingSince
      registrationDate
      picture {
        bucket
        region
        key
      }
      accountStatus
      qualifications {
        title
        dateAchieved
        attachment {
          bucket
          region
          key
        }
      }
      skills
      experienceInYears
      employmentHistory {
        jobTitle
        company
        location {
          city
          state
        }
        startDate
        endDate
        currentlyWorking
        description
      }
      customers {
        items {
          id
          inspectorID
          customerID
          offerMadeAt
          offerNote
          offerStatus
          offerAcceptedAt
          offerRejectionNote
          offerMadeByUserId
          createdAt
          updatedAt
        }
        nextToken
      }
      authorizedVehTypes
      userReviews {
        id
        reviewedby
        rating
        reviewTitle
        reviewDetails
        otherDetails
        reviewDate
      }
      remarks
      createdAt
      updatedAt
    }
  }
`;
export const updateInspector = /* GraphQL */ `
  mutation UpdateInspector(
    $input: UpdateInspectorInput!
    $condition: ModelInspectorConditionInput
  ) {
    updateInspector(input: $input, condition: $condition) {
      id
      name
      homeAddress
      city
      state
      phoneNo
      email
      overAllRating
      inspectingSince
      registrationDate
      picture {
        bucket
        region
        key
      }
      accountStatus
      qualifications {
        title
        dateAchieved
        attachment {
          bucket
          region
          key
        }
      }
      skills
      experienceInYears
      employmentHistory {
        jobTitle
        company
        location {
          city
          state
        }
        startDate
        endDate
        currentlyWorking
        description
      }
      customers {
        items {
          id
          inspectorID
          customerID
          offerMadeAt
          offerNote
          offerStatus
          offerAcceptedAt
          offerRejectionNote
          offerMadeByUserId
          createdAt
          updatedAt
        }
        nextToken
      }
      authorizedVehTypes
      userReviews {
        id
        reviewedby
        rating
        reviewTitle
        reviewDetails
        otherDetails
        reviewDate
      }
      remarks
      createdAt
      updatedAt
    }
  }
`;
export const deleteInspector = /* GraphQL */ `
  mutation DeleteInspector(
    $input: DeleteInspectorInput!
    $condition: ModelInspectorConditionInput
  ) {
    deleteInspector(input: $input, condition: $condition) {
      id
      name
      homeAddress
      city
      state
      phoneNo
      email
      overAllRating
      inspectingSince
      registrationDate
      picture {
        bucket
        region
        key
      }
      accountStatus
      qualifications {
        title
        dateAchieved
        attachment {
          bucket
          region
          key
        }
      }
      skills
      experienceInYears
      employmentHistory {
        jobTitle
        company
        location {
          city
          state
        }
        startDate
        endDate
        currentlyWorking
        description
      }
      customers {
        items {
          id
          inspectorID
          customerID
          offerMadeAt
          offerNote
          offerStatus
          offerAcceptedAt
          offerRejectionNote
          offerMadeByUserId
          createdAt
          updatedAt
        }
        nextToken
      }
      authorizedVehTypes
      userReviews {
        id
        reviewedby
        rating
        reviewTitle
        reviewDetails
        otherDetails
        reviewDate
      }
      remarks
      createdAt
      updatedAt
    }
  }
`;
export const createInspectorCustomer = /* GraphQL */ `
  mutation CreateInspectorCustomer(
    $input: CreateInspectorCustomerInput!
    $condition: ModelInspectorCustomerConditionInput
  ) {
    createInspectorCustomer(input: $input, condition: $condition) {
      id
      inspectorID
      customerID
      offerMadeAt
      offerNote
      offerStatus
      offerAcceptedAt
      offerRejectionNote
      offerMadeByUserId
      inspector {
        id
        name
        homeAddress
        city
        state
        phoneNo
        email
        overAllRating
        inspectingSince
        registrationDate
        picture {
          bucket
          region
          key
        }
        accountStatus
        qualifications {
          title
          dateAchieved
        }
        skills
        experienceInYears
        employmentHistory {
          jobTitle
          company
          startDate
          endDate
          currentlyWorking
          description
        }
        customers {
          nextToken
        }
        authorizedVehTypes
        userReviews {
          id
          reviewedby
          rating
          reviewTitle
          reviewDetails
          otherDetails
          reviewDate
        }
        remarks
        createdAt
        updatedAt
      }
      customer {
        id
        calbitCustomerID
        companyName
        customerFirstName
        customerLastName
        customerAddresses {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        email
        registrationDate
        picture {
          bucket
          region
          key
        }
        accountStatus
        customerOverAllRating
        vehicles {
          nextToken
        }
        customerTeam {
          nextToken
        }
        userReviews {
          id
          reviewedby
          rating
          reviewTitle
          reviewDetails
          otherDetails
          reviewDate
        }
        generalInstructions
        inspectors {
          nextToken
        }
        vendors {
          nextToken
        }
        registeredInspectionType
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateInspectorCustomer = /* GraphQL */ `
  mutation UpdateInspectorCustomer(
    $input: UpdateInspectorCustomerInput!
    $condition: ModelInspectorCustomerConditionInput
  ) {
    updateInspectorCustomer(input: $input, condition: $condition) {
      id
      inspectorID
      customerID
      offerMadeAt
      offerNote
      offerStatus
      offerAcceptedAt
      offerRejectionNote
      offerMadeByUserId
      inspector {
        id
        name
        homeAddress
        city
        state
        phoneNo
        email
        overAllRating
        inspectingSince
        registrationDate
        picture {
          bucket
          region
          key
        }
        accountStatus
        qualifications {
          title
          dateAchieved
        }
        skills
        experienceInYears
        employmentHistory {
          jobTitle
          company
          startDate
          endDate
          currentlyWorking
          description
        }
        customers {
          nextToken
        }
        authorizedVehTypes
        userReviews {
          id
          reviewedby
          rating
          reviewTitle
          reviewDetails
          otherDetails
          reviewDate
        }
        remarks
        createdAt
        updatedAt
      }
      customer {
        id
        calbitCustomerID
        companyName
        customerFirstName
        customerLastName
        customerAddresses {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        email
        registrationDate
        picture {
          bucket
          region
          key
        }
        accountStatus
        customerOverAllRating
        vehicles {
          nextToken
        }
        customerTeam {
          nextToken
        }
        userReviews {
          id
          reviewedby
          rating
          reviewTitle
          reviewDetails
          otherDetails
          reviewDate
        }
        generalInstructions
        inspectors {
          nextToken
        }
        vendors {
          nextToken
        }
        registeredInspectionType
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteInspectorCustomer = /* GraphQL */ `
  mutation DeleteInspectorCustomer(
    $input: DeleteInspectorCustomerInput!
    $condition: ModelInspectorCustomerConditionInput
  ) {
    deleteInspectorCustomer(input: $input, condition: $condition) {
      id
      inspectorID
      customerID
      offerMadeAt
      offerNote
      offerStatus
      offerAcceptedAt
      offerRejectionNote
      offerMadeByUserId
      inspector {
        id
        name
        homeAddress
        city
        state
        phoneNo
        email
        overAllRating
        inspectingSince
        registrationDate
        picture {
          bucket
          region
          key
        }
        accountStatus
        qualifications {
          title
          dateAchieved
        }
        skills
        experienceInYears
        employmentHistory {
          jobTitle
          company
          startDate
          endDate
          currentlyWorking
          description
        }
        customers {
          nextToken
        }
        authorizedVehTypes
        userReviews {
          id
          reviewedby
          rating
          reviewTitle
          reviewDetails
          otherDetails
          reviewDate
        }
        remarks
        createdAt
        updatedAt
      }
      customer {
        id
        calbitCustomerID
        companyName
        customerFirstName
        customerLastName
        customerAddresses {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        email
        registrationDate
        picture {
          bucket
          region
          key
        }
        accountStatus
        customerOverAllRating
        vehicles {
          nextToken
        }
        customerTeam {
          nextToken
        }
        userReviews {
          id
          reviewedby
          rating
          reviewTitle
          reviewDetails
          otherDetails
          reviewDate
        }
        generalInstructions
        inspectors {
          nextToken
        }
        vendors {
          nextToken
        }
        registeredInspectionType
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createInspection = /* GraphQL */ `
  mutation CreateInspection(
    $input: CreateInspectionInput!
    $condition: ModelInspectionConditionInput
  ) {
    createInspection(input: $input, condition: $condition) {
      id
      customerId
      vehicleId
      dvirVehicleInCombination
      inspectorUserType
      inspectorUserId
      vehicle {
        id
        customerVehicleId
        inspections {
          nextToken
        }
        customer {
          id
          calbitCustomerID
          companyName
          customerFirstName
          customerLastName
          email
          registrationDate
          accountStatus
          customerOverAllRating
          generalInstructions
          registeredInspectionType
          createdAt
          updatedAt
        }
        make
        model
        VIN
        vehicleYear
        license
        locationLat
        locationLong
        nextInspectionDue {
          inspectionType
          nextDueDate
        }
        notes
        deactivateBIT
        deactivateDOT
        currentMileage
        currentMileageLastUpdated
        vehicleType {
          id
          vehicleType
          vehicleCategory
          observations
          createdAt
          updatedAt
        }
        specialInstructions
        mainPic {
          bucket
          region
          key
        }
        vinPic {
          bucket
          region
          key
        }
        licensePic {
          bucket
          region
          key
        }
        vehicleUploads {
          bucket
          region
          key
        }
        oilService {
          oilServiceType
          intervalValue
          currentMileage
          currentMileageLastUpdated
          lastTimeOilChangedAt
        }
        filters {
          filterCategory
          filterNumber
          notes
        }
        specialParts {
          partName
          partNumber
        }
        vehicleStatus
        defects {
          nextToken
        }
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      inspectionType
      inspectionStatus
      startAt
      endAt
      nextInspectionDue
      inspectionObservations
      inspectionForm {
        bucket
        region
        key
      }
      inspectionUploads {
        bucket
        region
        key
      }
      inspectionReport {
        bucket
        region
        key
      }
      federalStickerUpdated
      notes
      createdAt
      updatedAt
    }
  }
`;
export const updateInspection = /* GraphQL */ `
  mutation UpdateInspection(
    $input: UpdateInspectionInput!
    $condition: ModelInspectionConditionInput
  ) {
    updateInspection(input: $input, condition: $condition) {
      id
      customerId
      vehicleId
      dvirVehicleInCombination
      inspectorUserType
      inspectorUserId
      vehicle {
        id
        customerVehicleId
        inspections {
          nextToken
        }
        customer {
          id
          calbitCustomerID
          companyName
          customerFirstName
          customerLastName
          email
          registrationDate
          accountStatus
          customerOverAllRating
          generalInstructions
          registeredInspectionType
          createdAt
          updatedAt
        }
        make
        model
        VIN
        vehicleYear
        license
        locationLat
        locationLong
        nextInspectionDue {
          inspectionType
          nextDueDate
        }
        notes
        deactivateBIT
        deactivateDOT
        currentMileage
        currentMileageLastUpdated
        vehicleType {
          id
          vehicleType
          vehicleCategory
          observations
          createdAt
          updatedAt
        }
        specialInstructions
        mainPic {
          bucket
          region
          key
        }
        vinPic {
          bucket
          region
          key
        }
        licensePic {
          bucket
          region
          key
        }
        vehicleUploads {
          bucket
          region
          key
        }
        oilService {
          oilServiceType
          intervalValue
          currentMileage
          currentMileageLastUpdated
          lastTimeOilChangedAt
        }
        filters {
          filterCategory
          filterNumber
          notes
        }
        specialParts {
          partName
          partNumber
        }
        vehicleStatus
        defects {
          nextToken
        }
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      inspectionType
      inspectionStatus
      startAt
      endAt
      nextInspectionDue
      inspectionObservations
      inspectionForm {
        bucket
        region
        key
      }
      inspectionUploads {
        bucket
        region
        key
      }
      inspectionReport {
        bucket
        region
        key
      }
      federalStickerUpdated
      notes
      createdAt
      updatedAt
    }
  }
`;
export const deleteInspection = /* GraphQL */ `
  mutation DeleteInspection(
    $input: DeleteInspectionInput!
    $condition: ModelInspectionConditionInput
  ) {
    deleteInspection(input: $input, condition: $condition) {
      id
      customerId
      vehicleId
      dvirVehicleInCombination
      inspectorUserType
      inspectorUserId
      vehicle {
        id
        customerVehicleId
        inspections {
          nextToken
        }
        customer {
          id
          calbitCustomerID
          companyName
          customerFirstName
          customerLastName
          email
          registrationDate
          accountStatus
          customerOverAllRating
          generalInstructions
          registeredInspectionType
          createdAt
          updatedAt
        }
        make
        model
        VIN
        vehicleYear
        license
        locationLat
        locationLong
        nextInspectionDue {
          inspectionType
          nextDueDate
        }
        notes
        deactivateBIT
        deactivateDOT
        currentMileage
        currentMileageLastUpdated
        vehicleType {
          id
          vehicleType
          vehicleCategory
          observations
          createdAt
          updatedAt
        }
        specialInstructions
        mainPic {
          bucket
          region
          key
        }
        vinPic {
          bucket
          region
          key
        }
        licensePic {
          bucket
          region
          key
        }
        vehicleUploads {
          bucket
          region
          key
        }
        oilService {
          oilServiceType
          intervalValue
          currentMileage
          currentMileageLastUpdated
          lastTimeOilChangedAt
        }
        filters {
          filterCategory
          filterNumber
          notes
        }
        specialParts {
          partName
          partNumber
        }
        vehicleStatus
        defects {
          nextToken
        }
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      inspectionType
      inspectionStatus
      startAt
      endAt
      nextInspectionDue
      inspectionObservations
      inspectionForm {
        bucket
        region
        key
      }
      inspectionUploads {
        bucket
        region
        key
      }
      inspectionReport {
        bucket
        region
        key
      }
      federalStickerUpdated
      notes
      createdAt
      updatedAt
    }
  }
`;
export const createDefect = /* GraphQL */ `
  mutation CreateDefect(
    $input: CreateDefectInput!
    $condition: ModelDefectConditionInput
  ) {
    createDefect(input: $input, condition: $condition) {
      id
      customerId
      vehicleId
      vehicle {
        id
        customerVehicleId
        inspections {
          nextToken
        }
        customer {
          id
          calbitCustomerID
          companyName
          customerFirstName
          customerLastName
          email
          registrationDate
          accountStatus
          customerOverAllRating
          generalInstructions
          registeredInspectionType
          createdAt
          updatedAt
        }
        make
        model
        VIN
        vehicleYear
        license
        locationLat
        locationLong
        nextInspectionDue {
          inspectionType
          nextDueDate
        }
        notes
        deactivateBIT
        deactivateDOT
        currentMileage
        currentMileageLastUpdated
        vehicleType {
          id
          vehicleType
          vehicleCategory
          observations
          createdAt
          updatedAt
        }
        specialInstructions
        mainPic {
          bucket
          region
          key
        }
        vinPic {
          bucket
          region
          key
        }
        licensePic {
          bucket
          region
          key
        }
        vehicleUploads {
          bucket
          region
          key
        }
        oilService {
          oilServiceType
          intervalValue
          currentMileage
          currentMileageLastUpdated
          lastTimeOilChangedAt
        }
        filters {
          filterCategory
          filterNumber
          notes
        }
        specialParts {
          partName
          partNumber
        }
        vehicleStatus
        defects {
          nextToken
        }
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      defectType
      defectDesc
      redTag
      priority
      status
      reportedByUserType
      reportedByUserId
      reportedDateTime
      sourceType
      sourceId
      assignedToUserType
      assignedToUserId
      assignedAtDateTime
      assignedByUserId
      assignmentNote
      isAccepted
      assignmentHistory {
        assignedToUserId
        assignedToUserType
        assignedAtDateTime
        assignmentNote
        refusedAtDateTime
        refusalNote
        assignedByUserId
      }
      repairedByUserType
      repairedByUserId
      repairedDateTime
      repairNotes
      partsUsedInRepair
      defectUploads {
        bucket
        region
        key
      }
      notes {
        items {
          id
          noteText
          noteType
          defectID
          addedByUserId
          addedByUserGroup
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateDefect = /* GraphQL */ `
  mutation UpdateDefect(
    $input: UpdateDefectInput!
    $condition: ModelDefectConditionInput
  ) {
    updateDefect(input: $input, condition: $condition) {
      id
      customerId
      vehicleId
      vehicle {
        id
        customerVehicleId
        inspections {
          nextToken
        }
        customer {
          id
          calbitCustomerID
          companyName
          customerFirstName
          customerLastName
          email
          registrationDate
          accountStatus
          customerOverAllRating
          generalInstructions
          registeredInspectionType
          createdAt
          updatedAt
        }
        make
        model
        VIN
        vehicleYear
        license
        locationLat
        locationLong
        nextInspectionDue {
          inspectionType
          nextDueDate
        }
        notes
        deactivateBIT
        deactivateDOT
        currentMileage
        currentMileageLastUpdated
        vehicleType {
          id
          vehicleType
          vehicleCategory
          observations
          createdAt
          updatedAt
        }
        specialInstructions
        mainPic {
          bucket
          region
          key
        }
        vinPic {
          bucket
          region
          key
        }
        licensePic {
          bucket
          region
          key
        }
        vehicleUploads {
          bucket
          region
          key
        }
        oilService {
          oilServiceType
          intervalValue
          currentMileage
          currentMileageLastUpdated
          lastTimeOilChangedAt
        }
        filters {
          filterCategory
          filterNumber
          notes
        }
        specialParts {
          partName
          partNumber
        }
        vehicleStatus
        defects {
          nextToken
        }
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      defectType
      defectDesc
      redTag
      priority
      status
      reportedByUserType
      reportedByUserId
      reportedDateTime
      sourceType
      sourceId
      assignedToUserType
      assignedToUserId
      assignedAtDateTime
      assignedByUserId
      assignmentNote
      isAccepted
      assignmentHistory {
        assignedToUserId
        assignedToUserType
        assignedAtDateTime
        assignmentNote
        refusedAtDateTime
        refusalNote
        assignedByUserId
      }
      repairedByUserType
      repairedByUserId
      repairedDateTime
      repairNotes
      partsUsedInRepair
      defectUploads {
        bucket
        region
        key
      }
      notes {
        items {
          id
          noteText
          noteType
          defectID
          addedByUserId
          addedByUserGroup
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteDefect = /* GraphQL */ `
  mutation DeleteDefect(
    $input: DeleteDefectInput!
    $condition: ModelDefectConditionInput
  ) {
    deleteDefect(input: $input, condition: $condition) {
      id
      customerId
      vehicleId
      vehicle {
        id
        customerVehicleId
        inspections {
          nextToken
        }
        customer {
          id
          calbitCustomerID
          companyName
          customerFirstName
          customerLastName
          email
          registrationDate
          accountStatus
          customerOverAllRating
          generalInstructions
          registeredInspectionType
          createdAt
          updatedAt
        }
        make
        model
        VIN
        vehicleYear
        license
        locationLat
        locationLong
        nextInspectionDue {
          inspectionType
          nextDueDate
        }
        notes
        deactivateBIT
        deactivateDOT
        currentMileage
        currentMileageLastUpdated
        vehicleType {
          id
          vehicleType
          vehicleCategory
          observations
          createdAt
          updatedAt
        }
        specialInstructions
        mainPic {
          bucket
          region
          key
        }
        vinPic {
          bucket
          region
          key
        }
        licensePic {
          bucket
          region
          key
        }
        vehicleUploads {
          bucket
          region
          key
        }
        oilService {
          oilServiceType
          intervalValue
          currentMileage
          currentMileageLastUpdated
          lastTimeOilChangedAt
        }
        filters {
          filterCategory
          filterNumber
          notes
        }
        specialParts {
          partName
          partNumber
        }
        vehicleStatus
        defects {
          nextToken
        }
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      defectType
      defectDesc
      redTag
      priority
      status
      reportedByUserType
      reportedByUserId
      reportedDateTime
      sourceType
      sourceId
      assignedToUserType
      assignedToUserId
      assignedAtDateTime
      assignedByUserId
      assignmentNote
      isAccepted
      assignmentHistory {
        assignedToUserId
        assignedToUserType
        assignedAtDateTime
        assignmentNote
        refusedAtDateTime
        refusalNote
        assignedByUserId
      }
      repairedByUserType
      repairedByUserId
      repairedDateTime
      repairNotes
      partsUsedInRepair
      defectUploads {
        bucket
        region
        key
      }
      notes {
        items {
          id
          noteText
          noteType
          defectID
          addedByUserId
          addedByUserGroup
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createDefectNote = /* GraphQL */ `
  mutation CreateDefectNote(
    $input: CreateDefectNoteInput!
    $condition: ModelDefectNoteConditionInput
  ) {
    createDefectNote(input: $input, condition: $condition) {
      id
      noteText
      noteAttachment {
        bucket
        region
        key
      }
      noteType
      defectID
      addedByUserId
      addedByUserGroup
      createdAt
      updatedAt
    }
  }
`;
export const updateDefectNote = /* GraphQL */ `
  mutation UpdateDefectNote(
    $input: UpdateDefectNoteInput!
    $condition: ModelDefectNoteConditionInput
  ) {
    updateDefectNote(input: $input, condition: $condition) {
      id
      noteText
      noteAttachment {
        bucket
        region
        key
      }
      noteType
      defectID
      addedByUserId
      addedByUserGroup
      createdAt
      updatedAt
    }
  }
`;
export const deleteDefectNote = /* GraphQL */ `
  mutation DeleteDefectNote(
    $input: DeleteDefectNoteInput!
    $condition: ModelDefectNoteConditionInput
  ) {
    deleteDefectNote(input: $input, condition: $condition) {
      id
      noteText
      noteAttachment {
        bucket
        region
        key
      }
      noteType
      defectID
      addedByUserId
      addedByUserGroup
      createdAt
      updatedAt
    }
  }
`;
export const createVehicle = /* GraphQL */ `
  mutation CreateVehicle(
    $input: CreateVehicleInput!
    $condition: ModelVehicleConditionInput
  ) {
    createVehicle(input: $input, condition: $condition) {
      id
      customerVehicleId
      inspections {
        items {
          id
          customerId
          vehicleId
          dvirVehicleInCombination
          inspectorUserType
          inspectorUserId
          inspectionType
          inspectionStatus
          startAt
          endAt
          nextInspectionDue
          inspectionObservations
          federalStickerUpdated
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      customer {
        id
        calbitCustomerID
        companyName
        customerFirstName
        customerLastName
        customerAddresses {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        email
        registrationDate
        picture {
          bucket
          region
          key
        }
        accountStatus
        customerOverAllRating
        vehicles {
          nextToken
        }
        customerTeam {
          nextToken
        }
        userReviews {
          id
          reviewedby
          rating
          reviewTitle
          reviewDetails
          otherDetails
          reviewDate
        }
        generalInstructions
        inspectors {
          nextToken
        }
        vendors {
          nextToken
        }
        registeredInspectionType
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      make
      model
      VIN
      vehicleYear
      license
      locationLat
      locationLong
      nextInspectionDue {
        inspectionType
        nextDueDate
      }
      notes
      deactivateBIT
      deactivateDOT
      currentMileage
      currentMileageLastUpdated
      vehicleType {
        id
        vehicleType
        vehicleCategory
        observations
        createdAt
        updatedAt
      }
      specialInstructions
      mainPic {
        bucket
        region
        key
      }
      vinPic {
        bucket
        region
        key
      }
      licensePic {
        bucket
        region
        key
      }
      vehicleUploads {
        bucket
        region
        key
      }
      oilService {
        oilServiceType
        intervalValue
        currentMileage
        currentMileageLastUpdated
        lastTimeOilChangedAt
      }
      filters {
        filterCategory
        filterNumber
        filterImage {
          bucket
          region
          key
        }
        notes
      }
      specialParts {
        partName
        partNumber
        partImage {
          bucket
          region
          key
        }
      }
      vehicleStatus
      defects {
        items {
          id
          customerId
          vehicleId
          defectType
          defectDesc
          redTag
          priority
          status
          reportedByUserType
          reportedByUserId
          reportedDateTime
          sourceType
          sourceId
          assignedToUserType
          assignedToUserId
          assignedAtDateTime
          assignedByUserId
          assignmentNote
          isAccepted
          repairedByUserType
          repairedByUserId
          repairedDateTime
          repairNotes
          partsUsedInRepair
          createdAt
          updatedAt
        }
        nextToken
      }
      defectsByStatus {
        items {
          id
          customerId
          vehicleId
          defectType
          defectDesc
          redTag
          priority
          status
          reportedByUserType
          reportedByUserId
          reportedDateTime
          sourceType
          sourceId
          assignedToUserType
          assignedToUserId
          assignedAtDateTime
          assignedByUserId
          assignmentNote
          isAccepted
          repairedByUserType
          repairedByUserId
          repairedDateTime
          repairNotes
          partsUsedInRepair
          createdAt
          updatedAt
        }
        nextToken
      }
      inspectionsByDueDate {
        items {
          id
          customerId
          vehicleId
          dvirVehicleInCombination
          inspectorUserType
          inspectorUserId
          inspectionType
          inspectionStatus
          startAt
          endAt
          nextInspectionDue
          inspectionObservations
          federalStickerUpdated
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateVehicle = /* GraphQL */ `
  mutation UpdateVehicle(
    $input: UpdateVehicleInput!
    $condition: ModelVehicleConditionInput
  ) {
    updateVehicle(input: $input, condition: $condition) {
      id
      customerVehicleId
      inspections {
        items {
          id
          customerId
          vehicleId
          dvirVehicleInCombination
          inspectorUserType
          inspectorUserId
          inspectionType
          inspectionStatus
          startAt
          endAt
          nextInspectionDue
          inspectionObservations
          federalStickerUpdated
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      customer {
        id
        calbitCustomerID
        companyName
        customerFirstName
        customerLastName
        customerAddresses {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        email
        registrationDate
        picture {
          bucket
          region
          key
        }
        accountStatus
        customerOverAllRating
        vehicles {
          nextToken
        }
        customerTeam {
          nextToken
        }
        userReviews {
          id
          reviewedby
          rating
          reviewTitle
          reviewDetails
          otherDetails
          reviewDate
        }
        generalInstructions
        inspectors {
          nextToken
        }
        vendors {
          nextToken
        }
        registeredInspectionType
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      make
      model
      VIN
      vehicleYear
      license
      locationLat
      locationLong
      nextInspectionDue {
        inspectionType
        nextDueDate
      }
      notes
      deactivateBIT
      deactivateDOT
      currentMileage
      currentMileageLastUpdated
      vehicleType {
        id
        vehicleType
        vehicleCategory
        observations
        createdAt
        updatedAt
      }
      specialInstructions
      mainPic {
        bucket
        region
        key
      }
      vinPic {
        bucket
        region
        key
      }
      licensePic {
        bucket
        region
        key
      }
      vehicleUploads {
        bucket
        region
        key
      }
      oilService {
        oilServiceType
        intervalValue
        currentMileage
        currentMileageLastUpdated
        lastTimeOilChangedAt
      }
      filters {
        filterCategory
        filterNumber
        filterImage {
          bucket
          region
          key
        }
        notes
      }
      specialParts {
        partName
        partNumber
        partImage {
          bucket
          region
          key
        }
      }
      vehicleStatus
      defects {
        items {
          id
          customerId
          vehicleId
          defectType
          defectDesc
          redTag
          priority
          status
          reportedByUserType
          reportedByUserId
          reportedDateTime
          sourceType
          sourceId
          assignedToUserType
          assignedToUserId
          assignedAtDateTime
          assignedByUserId
          assignmentNote
          isAccepted
          repairedByUserType
          repairedByUserId
          repairedDateTime
          repairNotes
          partsUsedInRepair
          createdAt
          updatedAt
        }
        nextToken
      }
      defectsByStatus {
        items {
          id
          customerId
          vehicleId
          defectType
          defectDesc
          redTag
          priority
          status
          reportedByUserType
          reportedByUserId
          reportedDateTime
          sourceType
          sourceId
          assignedToUserType
          assignedToUserId
          assignedAtDateTime
          assignedByUserId
          assignmentNote
          isAccepted
          repairedByUserType
          repairedByUserId
          repairedDateTime
          repairNotes
          partsUsedInRepair
          createdAt
          updatedAt
        }
        nextToken
      }
      inspectionsByDueDate {
        items {
          id
          customerId
          vehicleId
          dvirVehicleInCombination
          inspectorUserType
          inspectorUserId
          inspectionType
          inspectionStatus
          startAt
          endAt
          nextInspectionDue
          inspectionObservations
          federalStickerUpdated
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteVehicle = /* GraphQL */ `
  mutation DeleteVehicle(
    $input: DeleteVehicleInput!
    $condition: ModelVehicleConditionInput
  ) {
    deleteVehicle(input: $input, condition: $condition) {
      id
      customerVehicleId
      inspections {
        items {
          id
          customerId
          vehicleId
          dvirVehicleInCombination
          inspectorUserType
          inspectorUserId
          inspectionType
          inspectionStatus
          startAt
          endAt
          nextInspectionDue
          inspectionObservations
          federalStickerUpdated
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      customer {
        id
        calbitCustomerID
        companyName
        customerFirstName
        customerLastName
        customerAddresses {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        email
        registrationDate
        picture {
          bucket
          region
          key
        }
        accountStatus
        customerOverAllRating
        vehicles {
          nextToken
        }
        customerTeam {
          nextToken
        }
        userReviews {
          id
          reviewedby
          rating
          reviewTitle
          reviewDetails
          otherDetails
          reviewDate
        }
        generalInstructions
        inspectors {
          nextToken
        }
        vendors {
          nextToken
        }
        registeredInspectionType
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      make
      model
      VIN
      vehicleYear
      license
      locationLat
      locationLong
      nextInspectionDue {
        inspectionType
        nextDueDate
      }
      notes
      deactivateBIT
      deactivateDOT
      currentMileage
      currentMileageLastUpdated
      vehicleType {
        id
        vehicleType
        vehicleCategory
        observations
        createdAt
        updatedAt
      }
      specialInstructions
      mainPic {
        bucket
        region
        key
      }
      vinPic {
        bucket
        region
        key
      }
      licensePic {
        bucket
        region
        key
      }
      vehicleUploads {
        bucket
        region
        key
      }
      oilService {
        oilServiceType
        intervalValue
        currentMileage
        currentMileageLastUpdated
        lastTimeOilChangedAt
      }
      filters {
        filterCategory
        filterNumber
        filterImage {
          bucket
          region
          key
        }
        notes
      }
      specialParts {
        partName
        partNumber
        partImage {
          bucket
          region
          key
        }
      }
      vehicleStatus
      defects {
        items {
          id
          customerId
          vehicleId
          defectType
          defectDesc
          redTag
          priority
          status
          reportedByUserType
          reportedByUserId
          reportedDateTime
          sourceType
          sourceId
          assignedToUserType
          assignedToUserId
          assignedAtDateTime
          assignedByUserId
          assignmentNote
          isAccepted
          repairedByUserType
          repairedByUserId
          repairedDateTime
          repairNotes
          partsUsedInRepair
          createdAt
          updatedAt
        }
        nextToken
      }
      defectsByStatus {
        items {
          id
          customerId
          vehicleId
          defectType
          defectDesc
          redTag
          priority
          status
          reportedByUserType
          reportedByUserId
          reportedDateTime
          sourceType
          sourceId
          assignedToUserType
          assignedToUserId
          assignedAtDateTime
          assignedByUserId
          assignmentNote
          isAccepted
          repairedByUserType
          repairedByUserId
          repairedDateTime
          repairNotes
          partsUsedInRepair
          createdAt
          updatedAt
        }
        nextToken
      }
      inspectionsByDueDate {
        items {
          id
          customerId
          vehicleId
          dvirVehicleInCombination
          inspectorUserType
          inspectorUserId
          inspectionType
          inspectionStatus
          startAt
          endAt
          nextInspectionDue
          inspectionObservations
          federalStickerUpdated
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createVehicleType = /* GraphQL */ `
  mutation CreateVehicleType(
    $input: CreateVehicleTypeInput!
    $condition: ModelVehicleTypeConditionInput
  ) {
    createVehicleType(input: $input, condition: $condition) {
      id
      vehicleType
      vehicleCategory
      observations
      createdAt
      updatedAt
    }
  }
`;
export const updateVehicleType = /* GraphQL */ `
  mutation UpdateVehicleType(
    $input: UpdateVehicleTypeInput!
    $condition: ModelVehicleTypeConditionInput
  ) {
    updateVehicleType(input: $input, condition: $condition) {
      id
      vehicleType
      vehicleCategory
      observations
      createdAt
      updatedAt
    }
  }
`;
export const deleteVehicleType = /* GraphQL */ `
  mutation DeleteVehicleType(
    $input: DeleteVehicleTypeInput!
    $condition: ModelVehicleTypeConditionInput
  ) {
    deleteVehicleType(input: $input, condition: $condition) {
      id
      vehicleType
      vehicleCategory
      observations
      createdAt
      updatedAt
    }
  }
`;
export const createCustomer = /* GraphQL */ `
  mutation CreateCustomer(
    $input: CreateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    createCustomer(input: $input, condition: $condition) {
      id
      calbitCustomerID
      companyName
      customerFirstName
      customerLastName
      customerAddresses {
        phoneNo
        faxNo
        address
        city
        state
        zipCode
        addressType
        locationLat
        locationLong
      }
      email
      registrationDate
      picture {
        bucket
        region
        key
      }
      accountStatus
      customerOverAllRating
      vehicles {
        items {
          id
          customerVehicleId
          make
          model
          VIN
          vehicleYear
          license
          locationLat
          locationLong
          notes
          deactivateBIT
          deactivateDOT
          currentMileage
          currentMileageLastUpdated
          specialInstructions
          vehicleStatus
          createdAt
          updatedAt
        }
        nextToken
      }
      customerTeam {
        items {
          id
          empType
          empName
          phoneNo
          email
          accountStatus
          registrationDate
          notes
          username
          createdAt
          updatedAt
        }
        nextToken
      }
      userReviews {
        id
        reviewedby
        rating
        reviewTitle
        reviewDetails
        otherDetails
        reviewDate
      }
      generalInstructions
      inspectors {
        items {
          id
          inspectorID
          customerID
          offerMadeAt
          offerNote
          offerStatus
          offerAcceptedAt
          offerRejectionNote
          offerMadeByUserId
          createdAt
          updatedAt
        }
        nextToken
      }
      vendors {
        items {
          id
          vendorID
          customerID
          offerMadeAt
          offerNote
          offerStatus
          offerAcceptedAt
          offerRejectionNote
          offerMadeByUserId
          offerAcceptedByUserId
          createdAt
          updatedAt
        }
        nextToken
      }
      registeredInspectionType
      defectsByStatus {
        items {
          id
          customerId
          vehicleId
          defectType
          defectDesc
          redTag
          priority
          status
          reportedByUserType
          reportedByUserId
          reportedDateTime
          sourceType
          sourceId
          assignedToUserType
          assignedToUserId
          assignedAtDateTime
          assignedByUserId
          assignmentNote
          isAccepted
          repairedByUserType
          repairedByUserId
          repairedDateTime
          repairNotes
          partsUsedInRepair
          createdAt
          updatedAt
        }
        nextToken
      }
      inspectionsByDueDate {
        items {
          id
          customerId
          vehicleId
          dvirVehicleInCombination
          inspectorUserType
          inspectorUserId
          inspectionType
          inspectionStatus
          startAt
          endAt
          nextInspectionDue
          inspectionObservations
          federalStickerUpdated
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer(
    $input: UpdateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    updateCustomer(input: $input, condition: $condition) {
      id
      calbitCustomerID
      companyName
      customerFirstName
      customerLastName
      customerAddresses {
        phoneNo
        faxNo
        address
        city
        state
        zipCode
        addressType
        locationLat
        locationLong
      }
      email
      registrationDate
      picture {
        bucket
        region
        key
      }
      accountStatus
      customerOverAllRating
      vehicles {
        items {
          id
          customerVehicleId
          make
          model
          VIN
          vehicleYear
          license
          locationLat
          locationLong
          notes
          deactivateBIT
          deactivateDOT
          currentMileage
          currentMileageLastUpdated
          specialInstructions
          vehicleStatus
          createdAt
          updatedAt
        }
        nextToken
      }
      customerTeam {
        items {
          id
          empType
          empName
          phoneNo
          email
          accountStatus
          registrationDate
          notes
          username
          createdAt
          updatedAt
        }
        nextToken
      }
      userReviews {
        id
        reviewedby
        rating
        reviewTitle
        reviewDetails
        otherDetails
        reviewDate
      }
      generalInstructions
      inspectors {
        items {
          id
          inspectorID
          customerID
          offerMadeAt
          offerNote
          offerStatus
          offerAcceptedAt
          offerRejectionNote
          offerMadeByUserId
          createdAt
          updatedAt
        }
        nextToken
      }
      vendors {
        items {
          id
          vendorID
          customerID
          offerMadeAt
          offerNote
          offerStatus
          offerAcceptedAt
          offerRejectionNote
          offerMadeByUserId
          offerAcceptedByUserId
          createdAt
          updatedAt
        }
        nextToken
      }
      registeredInspectionType
      defectsByStatus {
        items {
          id
          customerId
          vehicleId
          defectType
          defectDesc
          redTag
          priority
          status
          reportedByUserType
          reportedByUserId
          reportedDateTime
          sourceType
          sourceId
          assignedToUserType
          assignedToUserId
          assignedAtDateTime
          assignedByUserId
          assignmentNote
          isAccepted
          repairedByUserType
          repairedByUserId
          repairedDateTime
          repairNotes
          partsUsedInRepair
          createdAt
          updatedAt
        }
        nextToken
      }
      inspectionsByDueDate {
        items {
          id
          customerId
          vehicleId
          dvirVehicleInCombination
          inspectorUserType
          inspectorUserId
          inspectionType
          inspectionStatus
          startAt
          endAt
          nextInspectionDue
          inspectionObservations
          federalStickerUpdated
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteCustomer = /* GraphQL */ `
  mutation DeleteCustomer(
    $input: DeleteCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    deleteCustomer(input: $input, condition: $condition) {
      id
      calbitCustomerID
      companyName
      customerFirstName
      customerLastName
      customerAddresses {
        phoneNo
        faxNo
        address
        city
        state
        zipCode
        addressType
        locationLat
        locationLong
      }
      email
      registrationDate
      picture {
        bucket
        region
        key
      }
      accountStatus
      customerOverAllRating
      vehicles {
        items {
          id
          customerVehicleId
          make
          model
          VIN
          vehicleYear
          license
          locationLat
          locationLong
          notes
          deactivateBIT
          deactivateDOT
          currentMileage
          currentMileageLastUpdated
          specialInstructions
          vehicleStatus
          createdAt
          updatedAt
        }
        nextToken
      }
      customerTeam {
        items {
          id
          empType
          empName
          phoneNo
          email
          accountStatus
          registrationDate
          notes
          username
          createdAt
          updatedAt
        }
        nextToken
      }
      userReviews {
        id
        reviewedby
        rating
        reviewTitle
        reviewDetails
        otherDetails
        reviewDate
      }
      generalInstructions
      inspectors {
        items {
          id
          inspectorID
          customerID
          offerMadeAt
          offerNote
          offerStatus
          offerAcceptedAt
          offerRejectionNote
          offerMadeByUserId
          createdAt
          updatedAt
        }
        nextToken
      }
      vendors {
        items {
          id
          vendorID
          customerID
          offerMadeAt
          offerNote
          offerStatus
          offerAcceptedAt
          offerRejectionNote
          offerMadeByUserId
          offerAcceptedByUserId
          createdAt
          updatedAt
        }
        nextToken
      }
      registeredInspectionType
      defectsByStatus {
        items {
          id
          customerId
          vehicleId
          defectType
          defectDesc
          redTag
          priority
          status
          reportedByUserType
          reportedByUserId
          reportedDateTime
          sourceType
          sourceId
          assignedToUserType
          assignedToUserId
          assignedAtDateTime
          assignedByUserId
          assignmentNote
          isAccepted
          repairedByUserType
          repairedByUserId
          repairedDateTime
          repairNotes
          partsUsedInRepair
          createdAt
          updatedAt
        }
        nextToken
      }
      inspectionsByDueDate {
        items {
          id
          customerId
          vehicleId
          dvirVehicleInCombination
          inspectorUserType
          inspectorUserId
          inspectionType
          inspectionStatus
          startAt
          endAt
          nextInspectionDue
          inspectionObservations
          federalStickerUpdated
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createCustomerTeam = /* GraphQL */ `
  mutation CreateCustomerTeam(
    $input: CreateCustomerTeamInput!
    $condition: ModelCustomerTeamConditionInput
  ) {
    createCustomerTeam(input: $input, condition: $condition) {
      id
      customer {
        id
        calbitCustomerID
        companyName
        customerFirstName
        customerLastName
        customerAddresses {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        email
        registrationDate
        picture {
          bucket
          region
          key
        }
        accountStatus
        customerOverAllRating
        vehicles {
          nextToken
        }
        customerTeam {
          nextToken
        }
        userReviews {
          id
          reviewedby
          rating
          reviewTitle
          reviewDetails
          otherDetails
          reviewDate
        }
        generalInstructions
        inspectors {
          nextToken
        }
        vendors {
          nextToken
        }
        registeredInspectionType
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      empType
      empName
      picture {
        bucket
        region
        key
      }
      phoneNo
      email
      accountStatus
      registrationDate
      notes
      username
      createdAt
      updatedAt
    }
  }
`;
export const updateCustomerTeam = /* GraphQL */ `
  mutation UpdateCustomerTeam(
    $input: UpdateCustomerTeamInput!
    $condition: ModelCustomerTeamConditionInput
  ) {
    updateCustomerTeam(input: $input, condition: $condition) {
      id
      customer {
        id
        calbitCustomerID
        companyName
        customerFirstName
        customerLastName
        customerAddresses {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        email
        registrationDate
        picture {
          bucket
          region
          key
        }
        accountStatus
        customerOverAllRating
        vehicles {
          nextToken
        }
        customerTeam {
          nextToken
        }
        userReviews {
          id
          reviewedby
          rating
          reviewTitle
          reviewDetails
          otherDetails
          reviewDate
        }
        generalInstructions
        inspectors {
          nextToken
        }
        vendors {
          nextToken
        }
        registeredInspectionType
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      empType
      empName
      picture {
        bucket
        region
        key
      }
      phoneNo
      email
      accountStatus
      registrationDate
      notes
      username
      createdAt
      updatedAt
    }
  }
`;
export const deleteCustomerTeam = /* GraphQL */ `
  mutation DeleteCustomerTeam(
    $input: DeleteCustomerTeamInput!
    $condition: ModelCustomerTeamConditionInput
  ) {
    deleteCustomerTeam(input: $input, condition: $condition) {
      id
      customer {
        id
        calbitCustomerID
        companyName
        customerFirstName
        customerLastName
        customerAddresses {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        email
        registrationDate
        picture {
          bucket
          region
          key
        }
        accountStatus
        customerOverAllRating
        vehicles {
          nextToken
        }
        customerTeam {
          nextToken
        }
        userReviews {
          id
          reviewedby
          rating
          reviewTitle
          reviewDetails
          otherDetails
          reviewDate
        }
        generalInstructions
        inspectors {
          nextToken
        }
        vendors {
          nextToken
        }
        registeredInspectionType
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      empType
      empName
      picture {
        bucket
        region
        key
      }
      phoneNo
      email
      accountStatus
      registrationDate
      notes
      username
      createdAt
      updatedAt
    }
  }
`;
export const createCustomerVendor = /* GraphQL */ `
  mutation CreateCustomerVendor(
    $input: CreateCustomerVendorInput!
    $condition: ModelCustomerVendorConditionInput
  ) {
    createCustomerVendor(input: $input, condition: $condition) {
      id
      vendorID
      customerID
      offerMadeAt
      offerNote
      offerStatus
      offerAcceptedAt
      offerRejectionNote
      offerMadeByUserId
      offerAcceptedByUserId
      vendor {
        id
        vendorType
        companyName
        firstName
        lastName
        phoneNo
        email
        address {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        accountStatus
        picture {
          bucket
          region
          key
        }
        vendorTeam {
          nextToken
        }
        customers {
          nextToken
        }
        notes
        createdAt
        updatedAt
      }
      customer {
        id
        calbitCustomerID
        companyName
        customerFirstName
        customerLastName
        customerAddresses {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        email
        registrationDate
        picture {
          bucket
          region
          key
        }
        accountStatus
        customerOverAllRating
        vehicles {
          nextToken
        }
        customerTeam {
          nextToken
        }
        userReviews {
          id
          reviewedby
          rating
          reviewTitle
          reviewDetails
          otherDetails
          reviewDate
        }
        generalInstructions
        inspectors {
          nextToken
        }
        vendors {
          nextToken
        }
        registeredInspectionType
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateCustomerVendor = /* GraphQL */ `
  mutation UpdateCustomerVendor(
    $input: UpdateCustomerVendorInput!
    $condition: ModelCustomerVendorConditionInput
  ) {
    updateCustomerVendor(input: $input, condition: $condition) {
      id
      vendorID
      customerID
      offerMadeAt
      offerNote
      offerStatus
      offerAcceptedAt
      offerRejectionNote
      offerMadeByUserId
      offerAcceptedByUserId
      vendor {
        id
        vendorType
        companyName
        firstName
        lastName
        phoneNo
        email
        address {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        accountStatus
        picture {
          bucket
          region
          key
        }
        vendorTeam {
          nextToken
        }
        customers {
          nextToken
        }
        notes
        createdAt
        updatedAt
      }
      customer {
        id
        calbitCustomerID
        companyName
        customerFirstName
        customerLastName
        customerAddresses {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        email
        registrationDate
        picture {
          bucket
          region
          key
        }
        accountStatus
        customerOverAllRating
        vehicles {
          nextToken
        }
        customerTeam {
          nextToken
        }
        userReviews {
          id
          reviewedby
          rating
          reviewTitle
          reviewDetails
          otherDetails
          reviewDate
        }
        generalInstructions
        inspectors {
          nextToken
        }
        vendors {
          nextToken
        }
        registeredInspectionType
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteCustomerVendor = /* GraphQL */ `
  mutation DeleteCustomerVendor(
    $input: DeleteCustomerVendorInput!
    $condition: ModelCustomerVendorConditionInput
  ) {
    deleteCustomerVendor(input: $input, condition: $condition) {
      id
      vendorID
      customerID
      offerMadeAt
      offerNote
      offerStatus
      offerAcceptedAt
      offerRejectionNote
      offerMadeByUserId
      offerAcceptedByUserId
      vendor {
        id
        vendorType
        companyName
        firstName
        lastName
        phoneNo
        email
        address {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        accountStatus
        picture {
          bucket
          region
          key
        }
        vendorTeam {
          nextToken
        }
        customers {
          nextToken
        }
        notes
        createdAt
        updatedAt
      }
      customer {
        id
        calbitCustomerID
        companyName
        customerFirstName
        customerLastName
        customerAddresses {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        email
        registrationDate
        picture {
          bucket
          region
          key
        }
        accountStatus
        customerOverAllRating
        vehicles {
          nextToken
        }
        customerTeam {
          nextToken
        }
        userReviews {
          id
          reviewedby
          rating
          reviewTitle
          reviewDetails
          otherDetails
          reviewDate
        }
        generalInstructions
        inspectors {
          nextToken
        }
        vendors {
          nextToken
        }
        registeredInspectionType
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createVendor = /* GraphQL */ `
  mutation CreateVendor(
    $input: CreateVendorInput!
    $condition: ModelVendorConditionInput
  ) {
    createVendor(input: $input, condition: $condition) {
      id
      vendorType
      companyName
      firstName
      lastName
      phoneNo
      email
      address {
        phoneNo
        faxNo
        address
        city
        state
        zipCode
        addressType
        locationLat
        locationLong
      }
      accountStatus
      picture {
        bucket
        region
        key
      }
      vendorTeam {
        items {
          id
          empType
          firstName
          lastName
          phoneNo
          email
          accountStatus
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      customers {
        items {
          id
          vendorID
          customerID
          offerMadeAt
          offerNote
          offerStatus
          offerAcceptedAt
          offerRejectionNote
          offerMadeByUserId
          offerAcceptedByUserId
          createdAt
          updatedAt
        }
        nextToken
      }
      notes
      createdAt
      updatedAt
    }
  }
`;
export const updateVendor = /* GraphQL */ `
  mutation UpdateVendor(
    $input: UpdateVendorInput!
    $condition: ModelVendorConditionInput
  ) {
    updateVendor(input: $input, condition: $condition) {
      id
      vendorType
      companyName
      firstName
      lastName
      phoneNo
      email
      address {
        phoneNo
        faxNo
        address
        city
        state
        zipCode
        addressType
        locationLat
        locationLong
      }
      accountStatus
      picture {
        bucket
        region
        key
      }
      vendorTeam {
        items {
          id
          empType
          firstName
          lastName
          phoneNo
          email
          accountStatus
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      customers {
        items {
          id
          vendorID
          customerID
          offerMadeAt
          offerNote
          offerStatus
          offerAcceptedAt
          offerRejectionNote
          offerMadeByUserId
          offerAcceptedByUserId
          createdAt
          updatedAt
        }
        nextToken
      }
      notes
      createdAt
      updatedAt
    }
  }
`;
export const deleteVendor = /* GraphQL */ `
  mutation DeleteVendor(
    $input: DeleteVendorInput!
    $condition: ModelVendorConditionInput
  ) {
    deleteVendor(input: $input, condition: $condition) {
      id
      vendorType
      companyName
      firstName
      lastName
      phoneNo
      email
      address {
        phoneNo
        faxNo
        address
        city
        state
        zipCode
        addressType
        locationLat
        locationLong
      }
      accountStatus
      picture {
        bucket
        region
        key
      }
      vendorTeam {
        items {
          id
          empType
          firstName
          lastName
          phoneNo
          email
          accountStatus
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      customers {
        items {
          id
          vendorID
          customerID
          offerMadeAt
          offerNote
          offerStatus
          offerAcceptedAt
          offerRejectionNote
          offerMadeByUserId
          offerAcceptedByUserId
          createdAt
          updatedAt
        }
        nextToken
      }
      notes
      createdAt
      updatedAt
    }
  }
`;
export const createVendorTeam = /* GraphQL */ `
  mutation CreateVendorTeam(
    $input: CreateVendorTeamInput!
    $condition: ModelVendorTeamConditionInput
  ) {
    createVendorTeam(input: $input, condition: $condition) {
      id
      vendor {
        id
        vendorType
        companyName
        firstName
        lastName
        phoneNo
        email
        address {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        accountStatus
        picture {
          bucket
          region
          key
        }
        vendorTeam {
          nextToken
        }
        customers {
          nextToken
        }
        notes
        createdAt
        updatedAt
      }
      empType
      firstName
      lastName
      phoneNo
      email
      accountStatus
      notes
      picture {
        bucket
        region
        key
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateVendorTeam = /* GraphQL */ `
  mutation UpdateVendorTeam(
    $input: UpdateVendorTeamInput!
    $condition: ModelVendorTeamConditionInput
  ) {
    updateVendorTeam(input: $input, condition: $condition) {
      id
      vendor {
        id
        vendorType
        companyName
        firstName
        lastName
        phoneNo
        email
        address {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        accountStatus
        picture {
          bucket
          region
          key
        }
        vendorTeam {
          nextToken
        }
        customers {
          nextToken
        }
        notes
        createdAt
        updatedAt
      }
      empType
      firstName
      lastName
      phoneNo
      email
      accountStatus
      notes
      picture {
        bucket
        region
        key
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteVendorTeam = /* GraphQL */ `
  mutation DeleteVendorTeam(
    $input: DeleteVendorTeamInput!
    $condition: ModelVendorTeamConditionInput
  ) {
    deleteVendorTeam(input: $input, condition: $condition) {
      id
      vendor {
        id
        vendorType
        companyName
        firstName
        lastName
        phoneNo
        email
        address {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        accountStatus
        picture {
          bucket
          region
          key
        }
        vendorTeam {
          nextToken
        }
        customers {
          nextToken
        }
        notes
        createdAt
        updatedAt
      }
      empType
      firstName
      lastName
      phoneNo
      email
      accountStatus
      notes
      picture {
        bucket
        region
        key
      }
      createdAt
      updatedAt
    }
  }
`;
export const createFastCustomer = /* GraphQL */ `
  mutation CreateFastCustomer(
    $input: CreateFastCustomerInput!
    $condition: ModelFastCustomerConditionInput
  ) {
    createFastCustomer(input: $input, condition: $condition) {
      id
      carrierName
      DOTNumber
      carrierAddress
      members {
        items {
          id
          customerId
          memberName
          phone
          email
          groupsAssigned
          createdAt
          updatedAt
        }
        nextToken
      }
      terminals {
        items {
          id
          customerId
          terminalName
          terminalAddress
          isDefault
          isDeactivated
          createdAt
          updatedAt
        }
        nextToken
      }
      vehicles {
        items {
          id
          vehicleId
          customerId
          terminalId
          isOutOfService
          isDeactivated
          type
          year
          make
          model
          nextDueDate
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateFastCustomer = /* GraphQL */ `
  mutation UpdateFastCustomer(
    $input: UpdateFastCustomerInput!
    $condition: ModelFastCustomerConditionInput
  ) {
    updateFastCustomer(input: $input, condition: $condition) {
      id
      carrierName
      DOTNumber
      carrierAddress
      members {
        items {
          id
          customerId
          memberName
          phone
          email
          groupsAssigned
          createdAt
          updatedAt
        }
        nextToken
      }
      terminals {
        items {
          id
          customerId
          terminalName
          terminalAddress
          isDefault
          isDeactivated
          createdAt
          updatedAt
        }
        nextToken
      }
      vehicles {
        items {
          id
          vehicleId
          customerId
          terminalId
          isOutOfService
          isDeactivated
          type
          year
          make
          model
          nextDueDate
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteFastCustomer = /* GraphQL */ `
  mutation DeleteFastCustomer(
    $input: DeleteFastCustomerInput!
    $condition: ModelFastCustomerConditionInput
  ) {
    deleteFastCustomer(input: $input, condition: $condition) {
      id
      carrierName
      DOTNumber
      carrierAddress
      members {
        items {
          id
          customerId
          memberName
          phone
          email
          groupsAssigned
          createdAt
          updatedAt
        }
        nextToken
      }
      terminals {
        items {
          id
          customerId
          terminalName
          terminalAddress
          isDefault
          isDeactivated
          createdAt
          updatedAt
        }
        nextToken
      }
      vehicles {
        items {
          id
          vehicleId
          customerId
          terminalId
          isOutOfService
          isDeactivated
          type
          year
          make
          model
          nextDueDate
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createFastMember = /* GraphQL */ `
  mutation CreateFastMember(
    $input: CreateFastMemberInput!
    $condition: ModelFastMemberConditionInput
  ) {
    createFastMember(input: $input, condition: $condition) {
      id
      customerId
      customer {
        id
        carrierName
        DOTNumber
        carrierAddress
        members {
          nextToken
        }
        terminals {
          nextToken
        }
        vehicles {
          nextToken
        }
        createdAt
        updatedAt
      }
      memberName
      phone
      email
      groupsAssigned
      createdAt
      updatedAt
    }
  }
`;
export const updateFastMember = /* GraphQL */ `
  mutation UpdateFastMember(
    $input: UpdateFastMemberInput!
    $condition: ModelFastMemberConditionInput
  ) {
    updateFastMember(input: $input, condition: $condition) {
      id
      customerId
      customer {
        id
        carrierName
        DOTNumber
        carrierAddress
        members {
          nextToken
        }
        terminals {
          nextToken
        }
        vehicles {
          nextToken
        }
        createdAt
        updatedAt
      }
      memberName
      phone
      email
      groupsAssigned
      createdAt
      updatedAt
    }
  }
`;
export const deleteFastMember = /* GraphQL */ `
  mutation DeleteFastMember(
    $input: DeleteFastMemberInput!
    $condition: ModelFastMemberConditionInput
  ) {
    deleteFastMember(input: $input, condition: $condition) {
      id
      customerId
      customer {
        id
        carrierName
        DOTNumber
        carrierAddress
        members {
          nextToken
        }
        terminals {
          nextToken
        }
        vehicles {
          nextToken
        }
        createdAt
        updatedAt
      }
      memberName
      phone
      email
      groupsAssigned
      createdAt
      updatedAt
    }
  }
`;
export const createFastTerminal = /* GraphQL */ `
  mutation CreateFastTerminal(
    $input: CreateFastTerminalInput!
    $condition: ModelFastTerminalConditionInput
  ) {
    createFastTerminal(input: $input, condition: $condition) {
      id
      customerId
      customer {
        id
        carrierName
        DOTNumber
        carrierAddress
        members {
          nextToken
        }
        terminals {
          nextToken
        }
        vehicles {
          nextToken
        }
        createdAt
        updatedAt
      }
      terminalName
      terminalAddress
      terminalPhoto {
        bucket
        region
        key
      }
      isDefault
      vehicles {
        items {
          id
          vehicleId
          customerId
          terminalId
          isOutOfService
          isDeactivated
          type
          year
          make
          model
          nextDueDate
          createdAt
          updatedAt
        }
        nextToken
      }
      isDeactivated
      createdAt
      updatedAt
    }
  }
`;
export const updateFastTerminal = /* GraphQL */ `
  mutation UpdateFastTerminal(
    $input: UpdateFastTerminalInput!
    $condition: ModelFastTerminalConditionInput
  ) {
    updateFastTerminal(input: $input, condition: $condition) {
      id
      customerId
      customer {
        id
        carrierName
        DOTNumber
        carrierAddress
        members {
          nextToken
        }
        terminals {
          nextToken
        }
        vehicles {
          nextToken
        }
        createdAt
        updatedAt
      }
      terminalName
      terminalAddress
      terminalPhoto {
        bucket
        region
        key
      }
      isDefault
      vehicles {
        items {
          id
          vehicleId
          customerId
          terminalId
          isOutOfService
          isDeactivated
          type
          year
          make
          model
          nextDueDate
          createdAt
          updatedAt
        }
        nextToken
      }
      isDeactivated
      createdAt
      updatedAt
    }
  }
`;
export const deleteFastTerminal = /* GraphQL */ `
  mutation DeleteFastTerminal(
    $input: DeleteFastTerminalInput!
    $condition: ModelFastTerminalConditionInput
  ) {
    deleteFastTerminal(input: $input, condition: $condition) {
      id
      customerId
      customer {
        id
        carrierName
        DOTNumber
        carrierAddress
        members {
          nextToken
        }
        terminals {
          nextToken
        }
        vehicles {
          nextToken
        }
        createdAt
        updatedAt
      }
      terminalName
      terminalAddress
      terminalPhoto {
        bucket
        region
        key
      }
      isDefault
      vehicles {
        items {
          id
          vehicleId
          customerId
          terminalId
          isOutOfService
          isDeactivated
          type
          year
          make
          model
          nextDueDate
          createdAt
          updatedAt
        }
        nextToken
      }
      isDeactivated
      createdAt
      updatedAt
    }
  }
`;
export const createFastVehicle = /* GraphQL */ `
  mutation CreateFastVehicle(
    $input: CreateFastVehicleInput!
    $condition: ModelFastVehicleConditionInput
  ) {
    createFastVehicle(input: $input, condition: $condition) {
      id
      vehicleId
      customerId
      customer {
        id
        carrierName
        DOTNumber
        carrierAddress
        members {
          nextToken
        }
        terminals {
          nextToken
        }
        vehicles {
          nextToken
        }
        createdAt
        updatedAt
      }
      terminalId
      isOutOfService
      isDeactivated
      type
      year
      make
      model
      photo {
        bucket
        region
        key
      }
      nextDueDate
      inspectionHistory {
        inspectionDate
        attachments {
          bucket
          region
          key
        }
        timeStamp
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateFastVehicle = /* GraphQL */ `
  mutation UpdateFastVehicle(
    $input: UpdateFastVehicleInput!
    $condition: ModelFastVehicleConditionInput
  ) {
    updateFastVehicle(input: $input, condition: $condition) {
      id
      vehicleId
      customerId
      customer {
        id
        carrierName
        DOTNumber
        carrierAddress
        members {
          nextToken
        }
        terminals {
          nextToken
        }
        vehicles {
          nextToken
        }
        createdAt
        updatedAt
      }
      terminalId
      isOutOfService
      isDeactivated
      type
      year
      make
      model
      photo {
        bucket
        region
        key
      }
      nextDueDate
      inspectionHistory {
        inspectionDate
        attachments {
          bucket
          region
          key
        }
        timeStamp
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteFastVehicle = /* GraphQL */ `
  mutation DeleteFastVehicle(
    $input: DeleteFastVehicleInput!
    $condition: ModelFastVehicleConditionInput
  ) {
    deleteFastVehicle(input: $input, condition: $condition) {
      id
      vehicleId
      customerId
      customer {
        id
        carrierName
        DOTNumber
        carrierAddress
        members {
          nextToken
        }
        terminals {
          nextToken
        }
        vehicles {
          nextToken
        }
        createdAt
        updatedAt
      }
      terminalId
      isOutOfService
      isDeactivated
      type
      year
      make
      model
      photo {
        bucket
        region
        key
      }
      nextDueDate
      inspectionHistory {
        inspectionDate
        attachments {
          bucket
          region
          key
        }
        timeStamp
      }
      createdAt
      updatedAt
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations.js